import { options } from '@/constants'

export * from './forms'
export * from './app'
export * from './offline'

export const getView = (width: number): string => {
  let newView = 'MobileView'
  if (width > 1220) {
    newView = 'DesktopView'
  } else if (width > 767) {
    newView = 'TabView'
  }
  return newView
}

export const isServer = typeof window === 'undefined'

export const getDefaultPath = (): string[] => {
  const getParent = (lastRoute: string | undefined): string[] => {
    const parent: string[] = []
    if (lastRoute !== '') return parent
    parent.push(lastRoute)
    options.forEach((option) => {
      if (option.children !== undefined) {
        option.children.forEach((child) => {
          if (child.key === lastRoute) {
            parent.push(option.key)
          }
        })
      }
    })
    return parent
  }

  if (!isServer && window.location.pathname !== '') {
    const routes = window.location.pathname.split('/')
    if (routes.length > 1) {
      const lastRoute = routes[routes.length - 1]
      return getParent(lastRoute)
    }
  }
  return []
}
